/**
 * Output formatting utilities.
 *
 * - Human mode: formatted tables to stdout
 * - JSON mode: raw JSON to stdout
 * - Errors always go to stderr
 */

let _quiet = false

export function setQuiet(value: boolean): void {
  _quiet = value
}

export function isQuiet(): boolean {
  return _quiet
}

export function printQuiet(value: string): void {
  process.stdout.write(value + `\n`)
}

export function printJson(data: unknown): void {
  process.stdout.write(JSON.stringify(data, null, 2) + `\n`)
}

export function printTable(headers: string[], rows: string[][]): void {
  if (rows.length === 0) {
    process.stdout.write(`No results found.\n`)
    return
  }

  // Calculate column widths
  const widths = headers.map((h, i) =>
    Math.max(h.length, ...rows.map((r) => (r[i] ?? ``).length))
  )

  // Print header
  const headerLine = headers
    .map((h, i) => h.toUpperCase().padEnd(widths[i]))
    .join(`  `)
  process.stdout.write(headerLine + `\n`)

  // Print rows
  for (const row of rows) {
    const line = row.map((cell, i) => (cell ?? ``).padEnd(widths[i])).join(`  `)
    process.stdout.write(line + `\n`)
  }
}

export function printSuccess(message: string): void {
  process.stdout.write(message + `\n`)
}

export function printKeyValue(pairs: [string, string][]): void {
  const maxKeyLen = Math.max(...pairs.map(([k]) => k.length))
  for (const [key, value] of pairs) {
    process.stdout.write(`${key.padEnd(maxKeyLen)}  ${value}\n`)
  }
}
